import { Component, OnInit, ViewChild, Compiler, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { RequestsService } from '../../services/requests.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Relatorio } from '../../models/relatorio.model';
import { Template } from '../../models/template.model';
import { LiveViewComponent } from '../../_helpers/livew-view/live-view.component';
import { drawDOM, exportPDF, DrawOptions, Group } from '@progress/kendo-drawing';
import { saveAs } from '@progress/kendo-file-saver';
import { defineFont } from '@progress/kendo-drawing/pdf';
import { AppModule } from '../../app.module';
import { CompileDirective } from '../directives/compile.directive';
import { DynamicComponent } from '../../_helpers/dynamic/dynamic.component';

defineFont({
  "DejaVu Sans": "https://kendo.cdn.telerik.com/2020.2.617/styles/fonts/DejaVu/DejaVuSans.ttf",
  "DejaVu Sans|Bold": "https://kendo.cdn.telerik.com/2020.2.617/styles/fonts/DejaVu/DejaVuSans-Bold.ttf",
  "DejaVu Sans|Bold|Italic": "https://kendo.cdn.telerik.com/2020.2.617/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
  "DejaVu Sans|Italic": "https://kendo.cdn.telerik.com/2020.2.617/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
  "WebComponentsIcons": "https://kendo.cdn.telerik.com/2020.2.617/styles/fonts/glyphs/WebComponentsIcons.ttf"
});

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {
  public teste = '<button (click)="context.alerta()">teste btn</button>'
  public corpo: string = "aqui esta o teste {{teste}}";
  public htmlHeader: string;
  public htmlBody: string;
  public template: Template;
  public fullScript: string;



  public data: Relatorio = new Relatorio();
  @ViewChild('live', { static: true }) private liveComponent: LiveViewComponent
  @ViewChild('live2', { static: true, read: ViewContainerRef }) private vcr: ViewContainerRef;

  constructor(private requestService: RequestsService, private route: ActivatedRoute, private componentFactoryResolver: ComponentFactoryResolver) {

  }

  async ngOnInit() {
    this['urlParams'] = {};
    this['nomeArquivo'] = "relatorio.pdf"
    this.route.queryParams.subscribe(params => {
      this.route.params.subscribe(pathParam => {

        Object.keys(params).forEach((index) => {
          this['urlParams'][index] = params[index];
        })
        let paramsString = JSON.stringify(params);
        this['urlParams']['idDistinctor'] = pathParam['idDistinctor'];
        this['urlParams']['idReport'] = pathParam['idReport'];

        this.requestService.getReportData(pathParam['idDistinctor'], pathParam['idReport'], paramsString).subscribe(result => {
          Object.keys(result).forEach((index) => {
            this[index] = result[index];


          });
          this.htmlBody = `<div id="loaded"></div>${this.htmlBody}`;

          let stringfyHeader = JSON.stringify(result.headerData);
          let stringfyBody = JSON.stringify(result.bodyData);
          this.fullScript = `let headerData = ${stringfyHeader}; 
                              let bodyData = ${stringfyBody};
                              ${result.scriptHeader ? result.scriptHeader : ""}
                              ${result.scriptBody ? result.scriptBody : ""}`;

                              this.loadScript(this.fullScript);

        });


      });
    });
   
  }



  public alerta() {

    alert();
  }

  async loadScript(script: string) {

    while (!document.getElementById("loaded")) {
      await new Promise(resolve => setTimeout(resolve, 1000));
    }

    let scriptElem = document.getElementById("customscript");
    if (scriptElem)
      scriptElem.remove();

    let dynamicScript = document.createElement("script");
    dynamicScript.id = "customscript";
    dynamicScript.type = "text/javascript";
    dynamicScript.async = true;
    dynamicScript.text = script;
    //   dynamicScript.text = `document.addEventListener("DOMContentLoaded", function(e) {
    //     ${}
    // });`;
    document.body.appendChild(dynamicScript);

  }

  exportPdf(data) {



    drawDOM(data, {
      paperSize: "A4", landscape: false,
      margin: { left: "0.5cm", right: "0.5cm", top: "0.5cm", bottom: "0.5cm" },
      scale: 0.50,
      repeatHeaders: true,
      template: (data) => `<span class="header" style="top: 20px;">Página ${data.pageNum} da ${data.totalPages}</span>`
    }).then((group: Group) => {
      exportPDF(group).then(data2 => {

        saveAs(data2, this["nomeArquivo"] ? this["nomeArquivo"] : "relatorio.pdf");
      });
    })



  }
  getObjectKeys(obj) {
    return Object.keys(obj);
  }

  groupBy(list, field) {
    var groups = new Set(list.map(item => item[field])),
      results = [];
    groups.forEach(g =>
      results.push({
        name: g,
        values: list.filter(i => i[field] === g)
      }
      ))
    return results;
  }

  sum(obj, nomeColuna) {
    let len = obj.length
    let total = 0

    for (let i = 0; i < len; i++) {
      total += obj[i][nomeColuna]
    }

    console.log(total)
    return total;

  }

  isArray(data) {
    return Array.isArray(data);
  }
}
